module.exports = __webpack_public_path__ + "static/revenus-pa-0723f21739ae46fb4ea6e210127eca51.svg";